import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { HEADER_LOGO_URL } from '../config/cloudinaryBrandImages';
import { adminLogin } from '../content/contentApi';
import './Admin.css';

export default function AdminLogin() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const sessionHint = searchParams.get('reason') === 'session';
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await adminLogin(email, password);
      navigate('/admin', { replace: true });
    } catch (err) {
      setError(err.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-root admin-login">
      <div className="admin-login-card">
        <img src={HEADER_LOGO_URL} alt="Databiqs" className="admin-login__logo" width={160} height={46} />
        <h1>Admin Panel</h1>
        <p>Sign in to update website content.</p>
        {sessionHint ? (
          <p className="admin-error" style={{ marginBottom: '0.75rem' }}>
            Your previous sign-in no longer works (session expired or the API target changed). Sign in
            again while <strong>npm run dev</strong> is running so saves go to your local CMS.
          </p>
        ) : null}
        {error ? <p className="admin-error">{error}</p> : null}
        <form onSubmit={handleSubmit}>
          <div className="admin-field">
            <label htmlFor="admin-email">Email</label>
            <input
              id="admin-email"
              type="email"
              autoComplete="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="admin-field">
            <label htmlFor="admin-password">Password</label>
            <input
              id="admin-password"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button type="submit" className="admin-btn admin-btn--primary" style={{ width: '100%' }} disabled={loading}>
            {loading ? 'Signing in…' : 'Sign in'}
          </button>
        </form>
      </div>
    </div>
  );
}
